import { jsx as _jsx } from "react/jsx-runtime";
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/org/$organization/$project/$application/settings/')({
    component: RouteComponent
});
function RouteComponent() {
    return /*#__PURE__*/ _jsx("div", {
        children: 'Hello "/org/$organization/$project/$application/settings/"!'
    });
}
